import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Broken-link chain — two ring halves with a diagonal break across
 *  them, so the silhouette reads as "link, but disconnected". Used
 *  for the SEO `nofollow` toggle. */
export function IcnLinkOff(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="link-off">
      <path d="M9.25 4.25 10.5 3a2.5 2.5 0 0 1 3.5 3.5l-1.25 1.25" />
      <path d="M6.75 11.75 5.5 13a2.5 2.5 0 0 1-3.5-3.5l1.25-1.25" />
      <line x1="2.75" y1="2.75" x2="13.25" y2="13.25" />
    </Svg>
  );
}
